import React from 'react';
import FieldMapSelector from '../components/fieldmap/FieldMapSelectorV2';
import { Box } from '@mui/material';

const Component = (props) => {
  return (
      <FieldMapSelector />
  );
};


export default Component;
